import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
`;

export const GroupInformation = styled.div`
`;

export const NoteHeader = styled.div`
    display: flex;
    font-size: 0.8em;
    color: #888;
`;

export const NoteDate = styled.div`
    margin-right: 10px
`;

export const NoteSource = styled.div`
    font-weight: bold;
`;

export const NoteValue = styled.div`
    color: #000;
    white-space: pre-wrap;
    overflow-wrap: break-word;
`;